module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.13/frontend/_next/static/images/banner-b10ac11b234914692de10413044f333d.png";